var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-breadcrumb',{key:_vm.isLoaded,attrs:{"items":_vm.allCrumbs},scopedSlots:_vm._u([{key:"separator",fn:function(){return [_c('span',{staticClass:"gl-mx-n5"},[_c('gl-icon',{attrs:{"name":"chevron-lg-right","size":8}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }